import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";

import type BriefSet from "./BriefSet";
import type Stream from "./Stream";

@Model()
class BriefSetsStreams extends ApplicationRecord {
  static jsonapiType = "brief_sets_streams";

  @BelongsTo() briefSet: BriefSet;

  @Attr() briefSetId: number;

  @Attr() primary: boolean;

  @BelongsTo() stream: Stream;

  @Attr() streamId: number;
}

export default BriefSetsStreams;
